import {ROUTES_LIST} from "@js-app/services/helpers/routes/const/routes-list";

class _RoutesHelper {
    routesList = ROUTES_LIST;

    getRoute(routeName, params = {}) {
        let _route = this.routesList[routeName] || null;

        if (!_route) {
            return null;
        }


        for (let paramKey in params) {
            _route = _route.replace(`:${paramKey}`, params[paramKey]);
        }

        return _route;
    }
}


export const RouteHelper = new _RoutesHelper();
